import PlatformActions from './PlatformActions'

export default class WINFINITYActions extends PlatformActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      gameType: 'LIVE',
      gameCode: 'WINFINITY-LIVE-001',
      platform: 'WINFINITY',
    }

    this.gameName = 'Bar Black Jack 5'

    this.constantGameInfo = {
      gtp: 'BlackJack',
      msid: '121eb8eb0335448ba5d2b02277b298ed',
      sid: 'bc03f62279ce4063860b5bd218f9a142',
    }
  }

  getBetMessage(txnList) {
    const { currency, supportPremium } = this.formData

    const txns = txnList.map(({
      userId,
      txnId,
      roundId,
      betTime,
      betAmount,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: txnId, // f7ad8dde07254ca8a236a43754590f85
      roundId, // 704534abcdf341e9abfbd505ac8a531f
      betType: null,
      currency,
      betTime, // 2025-04-07T15:00:50.360+08:00
      betAmount,
      jackpotBetAmount: 0,
      gameInfo: this.constantGameInfo,
      ...(supportPremium && { isPremium: false }),
    }))

    const message = {
      action: 'bet',
      txns,
    }

    return JSON.stringify(message)
  }

  getSettleMessage(txnList) {
    const txns = txnList.map(({
      userId,
      txnId,
      roundId,
      updateTime,
      betTime,
      turnover,
      betAmount,
      winAmount,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: txnId, // f7ad8dde07254ca8a236a43754590f85
      refPlatformTxId: null,
      settleType: 'platformTxId',
      updateTime, // 2025-04-07T15:01:23.933+08:00
      roundId, // 704534abcdf341e9abfbd505ac8a531f
      betType: null,
      betTime, // 2025-04-07T15:00:50.360+08:00
      txTime: betTime,
      turnover,
      betAmount,
      winAmount,
      jackpotWinAmount: 0,
    }))

    const message = {
      action: 'settle',
      txns,
    }

    return JSON.stringify(message)
  }

  getCancelBetMessage(txnList) {
    const txns = txnList.map(({
      userId,
      txnId,
      roundId,
    }) => ({
      ...this.constantTxnData,
      userId,
      platformTxId: txnId,
      roundId,
      gameInfo: this.constantGameInfo,
    }))

    const message = {
      action: 'cancelBet',
      txns,
    }

    return JSON.stringify(message)
  }
}
